exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme-color {\r\n  color: #84baad;\r\n}\r\n.lang:hover {\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n.navbar {\r\n  border-top: 25px solid #84baad;\r\n  -webkit-box-shadow: 0 1px 6px 2px rgba(0,0,0,.3);\r\n          box-shadow: 0 1px 6px 2px rgba(0,0,0,.3);\r\n  height: 85px;\r\n}\r\n.navbar-nav .nav-item {\r\n  margin: auto;\r\n}\r\n.navbar-nav .nav-item .nav-link {\r\n  color: #49525a;\r\n}\r\n.navbar-nav .nav-item .nav-link:hover {\r\n color: #84baad;\r\n}\r\n.navbar-brand img{\r\n  width: auto;\r\n  height: 44px;\r\n  padding-left: 20px;\r\n}\r\n.navbar .navbar-nav .nav-item a:hover{\r\n  color: #85baac;\r\n}\r\n@media (max-width: 767px) {\r\n  .navbar-brand img{\r\n    width: auto;\r\n    height: 44px;\r\n  }\r\n  .navbar {\r\n    padding-left: 0;\r\n    padding-bottom: 0;\r\n    padding-right: 0;\r\n  }\r\n  .navbar .navbar-nav {\r\n    background-color: #deedea;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/navbar/navbar.component.css
// module id = ../../../../../src/app/components/navbar/navbar.component.css
// module chunks = main